import { GlobalHotKeys, configure } from 'react-hotkeys';
import { useSearchStore } from '@/stores/search';
import { useHasNewNavigation, useHasNewSearchUI } from '@/hooks/featureFlags';

// this configuration is needed to allow the shortcut system to work with input fields
configure({
  /**
   * The HTML tags that React HotKeys should ignore key events from. This only works
   * if you are using the default ignoreEventsCondition function.
   * @type {String[]}
   */
  ignoreTags: ['input', 'select', 'textarea'],

  /**
   * The function used to determine whether a key event should be ignored by React
   * Hotkeys. By default, keyboard events originating elements with a tag name in
   * ignoreTags, or a isContentEditable property of true, are ignored.
   *
   * @type {Function<KeyboardEvent>}
   */
  ignoreEventsCondition: () => false,
});

export const shortcutElementNames = {
  mainSearch: 'MainSearch',
};

export const ShortcutSystem = () => {
  const { updateStore } = useSearchStore();

  const hasNewNavigation = useHasNewNavigation();
  const hasNewSearchUi = useHasNewSearchUI();
  const hasNewSearchUiEnabled = hasNewSearchUi && hasNewNavigation;

  const mainSearchInput = document.getElementsByName(
    shortcutElementNames.mainSearch,
  );

  const keyMap = {
    // if the new search UI is used on the new navigation, we will use the new Shortcut library to handle the hotkeys
    TOGGLE_SEARCH: !hasNewSearchUiEnabled ? ['F2', 'cmd+k', 'ctrl+k'] : [],
  };

  const toggleSearch = (event: KeyboardEvent | undefined) => {
    event?.preventDefault();

    updateStore({
      type: 'TOGGLE_SEARCH',
    });

    // main search input
    if (mainSearchInput.length > 0) {
      // Add an arbitrary timeout to ensure the element is rendered
      setTimeout(() => {
        mainSearchInput[0].focus();
      }, 100);
    }
  };

  const handlers = { TOGGLE_SEARCH: toggleSearch };

  return <GlobalHotKeys keyMap={keyMap} handlers={handlers} />;
};
